import React, { useState, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { AnimatePresence } from 'framer-motion';
import { theme } from './styles/theme';
import GlobalStyles from './styles/GlobalStyles';
import LoadingScreen from './components/LoadingScreen';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import About from './components/About';
import WhoWeAre from './components/WhoWeAre';
import Process from './components/Process';
import Products from './components/Products';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Empleo from './components/Empleo';

function Landing() {
  const [loading, setLoading] = useState(true);
  const handleFinish = useCallback(() => setLoading(false), []);

  return (
    <>
      <AnimatePresence>
        {loading && <LoadingScreen key="loader" onFinish={handleFinish} />}
      </AnimatePresence>
      {!loading && (
        <>
          <Navbar />
          <main>
            <Hero />
            <Stats />
            <WhoWeAre />
            <About />
            <Process />
            <Products />
            <Contact />
          </main>
          <Footer />
        </>
      )}
    </>
  );
}

function EmpleoPage() {
  return (
    <>
      <Navbar />
      <Empleo />
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/empleo" element={<EmpleoPage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
